var _defs, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModuleBasicPlatform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 3333.3333,
    height: 3333.3333,
    viewBox: "0 0 3333.3333 3333.3333",
    sodipodiDocname: "basic_platform.ai",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,2500 H 2500 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "basic_platform",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,3333.3333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(402,1509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-468.338 379.663,-848 848,-848 468.338,0 848,379.662 848,848 0,468.338 -379.662,848 -848,848 C 379.663,848 0,468.338 0,0",
    style: {
      fill: "#fdbb3b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(402,1509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-468.338 379.663,-848 848,-848 468.338,0 848,379.662 848,848 0,468.338 -379.662,848 -848,848 C 379.663,848 0,468.338 0,0 Z",
    style: {
      fill: "none",
      stroke: "#fdbb3b",
      strokeWidth: 60,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(1590.5,1796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -681 c -6.6,0 -12,-5.917 -12,-13.15 v -156.671 c 0,-0.526 0.037,-1.042 0.092,-1.553 C -688.712,-380.712 -532.543,-549 -340.5,-549 c 192.043,0 348.212,168.288 352.408,377.626 0.055,0.511 0.092,1.027 0.092,1.553 L 12,-13.15 C 12,-5.917 6.6,0 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(1590.5,1796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -681 c -6.6,0 -12,-5.917 -12,-13.15 v -156.671 c 0,-0.526 0.037,-1.042 0.092,-1.553 C -688.712,-380.712 -532.543,-549 -340.5,-549 c 192.043,0 348.212,168.288 352.408,377.626 0.055,0.511 0.092,1.027 0.092,1.553 L 12,-13.15 C 12,-5.917 6.6,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#00405a",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(1075.7751,1758.2407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -56 c -6.6,0 -12,5.4 -12,12 v 454.519 c 0,6.6 5.4,12 12,12 H 0 c 6.6,0 12,-5.4 12,-12 V 12 C 12,5.4 6.6,0 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(1075.7751,1758.2407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -56 c -6.6,0 -12,5.4 -12,12 v 454.519 c 0,6.6 5.4,12 12,12 H 0 c 6.6,0 12,-5.4 12,-12 V 12 C 12,5.4 6.6,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#00405a",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(1480.2249,1758.2407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -56 c -6.6,0 -12,5.4 -12,12 v 454.519 c 0,6.6 5.4,12 12,12 H 0 c 6.6,0 12,-5.4 12,-12 V 12 C 12,5.4 6.6,0 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(1480.2249,1758.2407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -56 c -6.6,0 -12,5.4 -12,12 v 454.519 c 0,6.6 5.4,12 12,12 H 0 c 6.6,0 12,-5.4 12,-12 V 12 C 12,5.4 6.6,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#00405a",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g50",
    transform: "translate(1613.0614,1778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -726.123 c -27.741,0 -50.438,22.697 -50.438,50.439 v 44.122 c 0,27.742 22.697,50.439 50.438,50.439 H 0 c 27.741,0 50.439,-22.697 50.439,-50.439 V 50.439 C 50.439,22.697 27.741,0 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "translate(1613.0614,1778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -726.123 c -27.741,0 -50.438,22.697 -50.438,50.439 v 44.122 c 0,27.742 22.697,50.439 50.438,50.439 H 0 c 27.741,0 50.439,-22.697 50.439,-50.439 V 50.439 C 50.439,22.697 27.741,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#00405a",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g58",
    transform: "translate(1315,1184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -65.431 -130 c -0.808,0.002 -5.046,0.096 -8.475,3.525 C -140.65,5.7 -142,8.7 -142,12 v 81 c 0,6.6 5.4,12 12,12 H 0 c 6.6,0 12,-5.4 12,-12 V 12 C 12,5.4 6.6,0 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62",
    transform: "translate(1315,1184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -65.431 -130 c -0.808,0.002 -5.046,0.096 -8.475,3.525 C -140.65,5.7 -142,8.7 -142,12 v 81 c 0,6.6 5.4,12 12,12 H 0 c 6.6,0 12,-5.4 12,-12 V 12 C 12,5.4 6.6,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#00405a",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(1251.5365,1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.565,-5.569 -0.159,-152.467 0.418,-168.835 6,-327.173 274,-223.947 280,-380.535 285.427,-522.175 158.464,-531 -1.565,-531 -179.536,-531 -300.923,-379.282 -306,-371.787",
    style: {
      fill: "none",
      stroke: "#00405a",
      strokeWidth: 90,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path68"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleBasicPlatform);
export default __webpack_public_path__ + "static/media/module-basic-platform.9155048fa87be593ee6eb798e8e34df0.svg";
export { ForwardRef as ReactComponent };